// App.tsx
import React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import Banner from './components/Banner';
import HomePage from './HomePage';
import ArgumentPage from './ArgumentPage';
import theme from './theme';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Helmet>
        <title>Impartial | AI-Powered Argument Resolution</title>
        <meta name="description" content="Resolve arguments fairly with AI" />

        {/* Google AdSense */}
        <script 
          async 
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7480950262636097"
        />
        
        {/* Google Analytics */}
        <script 
          async 
          src="https://www.googletagmanager.com/gtag/js?id=G-WB99WZ0FHX"
        />
        <script>
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', 'G-WB99WZ0FHX');
          `}
        </script>
      </Helmet>
      <Banner />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/argument/:id" element={<ArgumentPage />} />
        <Route path="/add-side-of-argument/:uid/:originatorName/:topic" element={<ArgumentPage />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
